import { Component, Input, OnInit } from '@angular/core';
import { IboxtoolsItem } from 'app/models/iboxtools-item';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ErroresService } from '../../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ConfigDataService } from '../../../../services/config-data.service';
import { SueldoBasico } from '../../../../models/sueldo-basico';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { SueldoBasicoService } from '../../../../services/sueldo-basico.service';
import { Concepto } from '../../../../models/concepto';
import { SueldoEditarDialogComponent } from '../sueldo-editar-dialog/sueldo-editar-dialog.component';
import { DatosOrganizativosService } from '../../../../services/datosOrganizativos.service';
import {MyValidations} from '../../../../utils/my-validations';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { PersonalService } from '../../../../services/personal.service';
import { formatDate } from '@angular/common';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-sueldo',
  templateUrl: './sueldo.component.html',
  styleUrls: ['./sueldo.component.css']
})
export class SueldoComponent implements OnInit {
  mensajeExitoGuardado: string;
  estructuraSalariales: any;

  constructor(private configDataSrv: ConfigDataService,
              private sueldoBasicoService: SueldoBasicoService, 
              private fb: FormBuilder, 
              private dialog: MatDialog, 
              private snackBar: MatSnackBar, 
              private datosOrganizativosSrv: DatosOrganizativosService,
              private erroresService: ErroresService,
              private gruposLiquidacionService: GruposLiquidacionService,
              private personalService: PersonalService,
              private momentService: MomentSetService ) { }

  @Input() legajo;
  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;

  sueldo: SueldoBasico;
  conceptosList: any;
  form: FormGroup;
  sueldoBasicoList: any[];
  nivelList: any;
  subnivelList: any;
  monedasList: any;
  cortarRegistro: boolean = false;

  datosO: any;

  MensajeError: string;
  disabledEditing: boolean = true;
  eliminando: boolean;
  eliminacionInvalida: boolean;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  submitted = false;

  sueldoBasicoHistoryList: any;
  toolboxEnabled: boolean = false;
  onlyNew: boolean = false;

  totalConceptos: number;
  totalImporte: number;
  monedaConcepto: string;
  
  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  sueldoInvalida: boolean = false;
  verFueraRango: boolean = false;
  public cargaCompleta = false;
  MensajeRetro = "";

  get registerFormControl() { return this.form?.controls; }

  ngOnInit(): void
  {
    this.configDataSrv.getSueldos()
      .subscribe(
        data => {
          this.nivelList=data["Niveles"];
          this.subnivelList=data["SubNiveles"];
          this.monedasList=data["Monedas"];
        },
        error => {
          console.log(error);
        });
    
    this.sueldoBasicoService.getEstructuraSalarial().subscribe(data => {this.estructuraSalariales = data});
    this.datosOrganizativosSrv.getByPersonalId(this.personalId).subscribe(
    data => 
    { 
      data.data.forEach((currentValue,index,arr) => {
        currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
        currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
      });
      this.datosO = data.data;
    });
    
    this.configurarValidadores();
    this.obtenerActual();
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Sueldo Basico")) this.permisoEdicion = true;
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      personal: ['', Validators.required],
      nivel: ['', Validators.required],
      subNivel: ['', Validators.required],
      estructuraSalarialId: ['', Validators.required],
      fechaVer: [new Date()]
    });
  }

  cargarEstructurasSalariales(desde,hasta)
  {
    let paisPersonal = null;
    this.estructuraSalariales = null;
    let index = this.datosO.findIndex(x => Date.parse(x.desde) <= Date.parse(desde) &&
                                            Date.parse(x.hasta) >= Date.parse(desde) );
    if (index != -1)
    {
      paisPersonal = this.datosO[index].sociedadNavigation.pais;
    }
    
    this.sueldoBasicoService.getEstructuraSalarialByPais(paisPersonal).subscribe(data =>
    {
      this.estructuraSalariales = data;
    });
  }

  cargarConceptos()
  {
    let fecha = this.form.get("fechaVer").value;
    fecha = this.momentService.saveDateServer(new Date(fecha.toDateString() + " 00:00:00"), true);

    let estructura = this.form.controls['estructuraSalarialId'].value;

    this.sueldoBasicoService.mostrarEstructura(estructura, fecha, parseInt(this.sueldoBasicoId()), this.form.getRawValue()).subscribe(
    data =>
    {
        this.conceptosList = data;
        this.calcularTotalConceptos(data);
    });      
  }

  onChangeFechas() {
    let desde = this.form.get("desde").value;
    let hasta = this.form.get("hasta").value;
    this.cargarEstructurasSalariales(desde,hasta); 
    this.chequeoRetro();   
  }

  
  setearForm(sueldoBasico: SueldoBasico)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(sueldoBasico?.id);
      this.form.controls['personal'].setValue(sueldoBasico?.personal);
      this.form.controls['desde'].setValue(new Date(sueldoBasico?.desde));
      this.form.controls['hasta'].setValue(new Date(sueldoBasico?.hasta));
      this.form.controls['estructuraSalarialId'].setValue(sueldoBasico?.estructuraSalarialId);
      this.form.controls['nivel'].setValue(sueldoBasico?.nivel);
      this.form.controls['subNivel'].setValue(sueldoBasico?.subNivel);

      if (sueldoBasico != null && sueldoBasico.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }

      this.cargarEstructurasSalariales(new Date(sueldoBasico?.desde), new Date(sueldoBasico?.hasta));
      this.chequeoRetro();
      this.cargarConceptos();

    }
  }

  calcularTotalConceptos(conceptos: Concepto[])
  {
    let total = 0;
    let totalImporte = 0;
    for (let concepto of conceptos)
    {
      total += 1;
      totalImporte += concepto.importe;
    }

    this.totalConceptos = total;
    this.totalImporte = totalImporte;

    if (conceptos.length > 0)
    {
      this.monedaConcepto = conceptos[0].monedaNavigation.descripcion;
    }
    else
    {
      this.monedaConcepto = '';
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
    }
    this.form.controls['fechaVer'].enable();
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.sueldo))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.sueldoBasicoService.delete(this.sueldo.id).subscribe(
            response =>
            {
              this.snackBar.open("Sueldo basico eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              this.obtenerActual();
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.sueldo))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['desde'].disable();
        $this.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let sueldoBasico = this.sueldoBasicoList.find(d => d.id == index);
    this.sueldo = sueldoBasico;
    this.setearForm(this.sueldo);
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.onlyNew = false;
    if (this.sueldoBasicoList != undefined)
    {
      if (this.sueldo.id == 0 && this.sueldoBasicoList.length == 0)
      {
        this.sueldo = null;
        this.conceptosList = null;
      }
      else if (this.sueldo.id == 0 && this.sueldoBasicoList.length > 0)
      {
        this.sueldo = this.sueldoBasicoList[0];
      }
    }
    else
    {
      this.sueldo = null;
      this.conceptosList = null;
    }

    
    this.setearForm(this.sueldo);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    this.submitted = true;
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.form.getRawValue();

      let datosSuel: SueldoBasico = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        nivel: formulario.nivel,
        subNivel: formulario.subNivel,
        estructuraSalarialId: formulario.estructuraSalarialId,
        sueldoBasicoConcepto: []
      };

      this.sueldoBasicoService.save(datosSuel, [], this.cortarRegistro).subscribe(
        sueldo =>
        {
          sueldo.desde = this.momentService.convertDateServer(sueldo.desde);
          sueldo.hasta = this.momentService.convertDateServer(sueldo.hasta);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Sueldo guardado", "OK", { duration: 10000 });
          this.onlyNew = false;
          this.deshabilitarEdicion();

          this.obtenerHistorial();
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //sueldo.desde = sueldo.desde.replace('Z', '');
          this.setearForm(sueldo);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.sueldoInvalida = true;
            
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.onlyNew = true;
      let fdesde = new Date().toString();
      let fecha = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
      if (fecha != undefined){
        fdesde = fecha.desde
      }
      let sueldo: SueldoBasico = { id: 0, personal: this.personalId, desde: fdesde, hasta: new Date("2999-12-31T23:59:59").toString(), estructuraSalarialId: 0, sueldoBasicoConcepto: [] };
      this.sueldo = sueldo;
      this.setearForm(sueldo);

      this.habilitarEdicion();
      this.form.controls['id'].setValue(0);
      this.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.onlyNew = true;
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['hasta'].disable();
      });
    }
  }

  add()
  {    
    this.OnNewChange(true);
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarForm(false);
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarForm(true);
  }

  private volverAtras()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.sueldoBasicoHistoryList = [];
    this.sueldoBasicoList = [];
    this.habilitarForm(false);
  }

  private obtenerHistorial()
  {
    this.sueldoBasicoService.getHistoryByPersonalId(this.personalId).subscribe(
      sueldo =>
      {
        sueldo.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.sueldoBasicoHistoryList = [];

        if (sueldo.length > 0)
        {
          sueldo.forEach(d =>
          {
            let item = new IboxtoolsItem(d);
            this.sueldoBasicoHistoryList.push(item);
          });

          this.sueldoBasicoList = sueldo;
        }
        else
        {
          this.setearForm(null);
          this.sueldo = null;
          this.conceptosList = null;
          this.sueldoBasicoList = [];
        }
      },
      error =>
      {
        console.log(error);
      });
  }

  private obtenerActual()
  {
    let fechaHoy = new Date();
    this.sueldoBasicoService.getByPersonalId(this.personalId).subscribe(
      sueldos =>
      {
        sueldos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        if (sueldos.length > 0)
        {
          this.sueldo = sueldos.find(f=> Date.parse(f.desde) <= fechaHoy.getTime() &&
                                         Date.parse(f.hasta) >= fechaHoy.getTime());
          
          if (this.sueldo == null) this.sueldo = sueldos[0];
          this.obtenerHistorial();
        }
        else
        {
          this.sueldo = null;
          this.conceptosList = null;
        }
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    if (this.form.get("estructuraSalarialId").value == 0)
    {
      this.form.get("estructuraSalarialId").setErrors({ 'invalid': true });
    }

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.form.get("desde").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.form.valid)
    {
      return true;
    }
    else
    {
      this.form.markAllAsTouched();
      return false;
    }
  }

  addConcepto(e)
  {
    let mone = 1;
    if (this.datosO[0].sociedadNavigation.moneda != undefined){
      mone = this.datosO[0].sociedadNavigation.moneda 
    }
    let concepto: Concepto = {
      id: 0,
      idSueldoBasico: this.sueldo.id,
      moneda: mone
    };

    this.abrirDialogo(concepto, 0);
  }

  abrirDialogo(concepto: Concepto, index: number)
  {
    let monedas = this.monedasList.filter(f => f.id == concepto.moneda);
    let desde = this.form.get("desde").value;
    let hasta = this.form.get("hasta").value;

    let dialogRef = this.dialog.open(SueldoEditarDialogComponent, {
      width: '700px',
      panelClass: 'overflow',
      data: { param: concepto,
              monedasList: monedas,
              desde: desde,
              hasta: hasta},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result != '')
      {
        if (concepto.id == 0)
        {
          this.conceptosList.unshift(result);
          this.mensajeExitoGuardado = "Datos guardados";
        }
        else
        {
          this.conceptosList[index] = result;
          this.mensajeExitoGuardado = "Datos actualizados";
        }

        this.conceptosList = [...this.conceptosList];

        this.cargarConceptos();
        this.calcularTotalConceptos(this.conceptosList);

        this.snackBar.open(this.mensajeExitoGuardado, "OK", { duration: 10000 });
      }
    });
  }

  editConcepto(row, rowIndex)
  {
    this.abrirDialogo(row, rowIndex);
  }

  deleteConcepto(row, rowIndex)
  {
    let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result)
      {
        if (this.sueldo.id == 0)
        {
          this.conceptosList.splice(rowIndex, 1);

          this.cargarConceptos();
          this.calcularTotalConceptos(this.conceptosList);
          return;
        }

        let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
          width: '400px'
        });
        dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

        this.eliminando = true;
        this.sueldoBasicoService.deleteConcepto(row.id).subscribe(
          response =>
          {
            let index = this.conceptosList.findIndex(x => x.id == row.id);
            if (index != -1)
            {
              this.conceptosList.splice(index, 1);
              this.conceptosList = [...this.conceptosList];
            }

            this.cargarConceptos();
            this.calcularTotalConceptos(this.conceptosList);

            this.snackBar.open("Eliminacion de concepto correcta.", "OK", { duration: 10000 });

            this.eliminando = false;

            setTimeout(function ()
            {
              dialogProcesandoRef.close();
            });
          },
          error =>
          {
            if (error.status == 400)
            {
              this.eliminacionInvalida = true;
            }
            else
            {
              this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
            }
            this.eliminando = false;
            dialogProcesandoRef.close();
          });
      }
    });
  }

  sueldoBasicoId()
  {
      let id = "";
      if (this.form.controls['id'] != null)
      {
        id = this.form.controls['id'].value;
      }

      return id;
  }

  cambioFechaVer()
  {
    //Valido que no se salga del rango del sueldo
    this.MensajeError = "";

    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    let ver = this.form.get("fechaVer").value.toDateString();

    this.verFueraRango = false;
    if (Date.parse(ver) < Date.parse(desde) || Date.parse(ver) > Date.parse(hasta))
    {
      this.verFueraRango = true;
      this.form.get("fechaVer").setErrors({ 'fuera': true });
    } else
    {
      this.cargarConceptos();
    }
  }

  chequeoRetro()
  {
    this.MensajeRetro = "";
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    
    this.personalService.ChequeoRetroactividad(this.personalId, 'SueldoBasico', desde, hasta, true).subscribe(
      data =>
      {
        let resul = data;
        if (resul.haceRetro)
        {
          let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
          this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
        }
      }
    );
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }

  
}
